import React from "react";
import { useTranslation } from "react-i18next";

import { Typography } from "antd";
const { Text } = Typography;

import { fontWeights, sizes } from "../constant/styles";
import { ERROR_50, ERROR_600 } from "../constant/colors";

export const DeceasedLabel = () => {
  const { t } = useTranslation();

  return (
    <Text
      style={{
        background: ERROR_50,
        color: ERROR_600,
        fontSize: sizes.medium,
        fontWeight: fontWeights.bold,
        borderRadius: "16px",
        display: "flex",
        justifyContent: "center",
        width: "105px"
      }}
    >
      {t("deceased")}
    </Text>
  );
};
